import React, { useEffect, useState } from "react";
import { Header, DefaultSideBar } from "components";
import { detailBatch } from "services/batch";
import TableEditBatch from "components/TableEditBatch";
import { useLocation } from 'react-router-dom';

export default function EditBatch() {
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const id = queryParams.get('id');

	const [data, setData] = useState(null);
	const [unfilteredData, setUnfilteredData] = useState(null);
	const [selectedMaturity, setSelectedMaturity] = useState('');
	const [selectedFinancing, setSelectedFinancing] = useState('');

	const fetchData = async () => {
		try {
			const batchData = await detailBatch(id, "", selectedMaturity, "", selectedFinancing);
			setData(batchData.data.batching_data);
			if (selectedMaturity === "" && selectedFinancing === "") {
				setUnfilteredData(batchData.data.batching_data);
			}
		} catch (error) {
			console.log("Error fetching batch data:", error);
		}
	};

	useEffect(() => {
		fetchData();
	}, [selectedMaturity, selectedFinancing]);

	const handleMaturityChange = (criteria) => {
		setSelectedMaturity(criteria.value);
	};

	const handleFinancingChange = (criteria) => {
		setSelectedFinancing(criteria.value);
	};

	return (
		<div className=" w-full relative bg-gray-100 pl-[81px] pt-[10vh]">
			<Header />
			<DefaultSideBar />
			{ data ? (
				<div className="flex flex-col items-start justify-start w-full mt-5 gap-[17px] px-10">
					<TableEditBatch data={ data.batching_data } unfilteredData={ unfilteredData.batching_data } regId={ data.registration_id } noBatch={ data.id } onFinancingChange={ handleFinancingChange } onMaturityChange={ handleMaturityChange } />
				</div>
			) : (
				<div className="flex w-full h-[90vh] justify-center items-center">Loading...</div>
			) }
		</div>
	);
}
